import React from 'react';
import cn from 'classnames';
import { func, bool } from 'prop-types';
import { noop } from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import './index.scss';
import { useFavoriteButton } from './hooks/useFavoriteButton';

const FavoriteButton = ({ onChange = noop, isFavorite = false }) => {
    const { isActive, updateActiveState } = useFavoriteButton({ onChange, isFavorite });

    return (
        <button
            type="button"
            className={cn('favorite hint--bottom-right', { active: isActive })}
            onClick={(e) => updateActiveState(e, !isActive)}
            data-hint={translate(`variations_display.favorite.${isActive ? 'remove' : 'add'}`)}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22.62" height="22.62">
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M16 1v8"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M26.607 5.393L20.95 11.05"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M31 16h-8"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M26.607 26.607L20.95 20.95"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M16 31v-8"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M5.393 26.607l5.657-5.657"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M1 16h8"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="line"
                    fill="none"
                    stroke="#E86C60"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    d="M5.393 5.393l5.657 5.657"
                    strokeDasharray="8.1 8.1"
                    strokeDashoffset="8.10"
                    opacity="0"
                />
                <path
                    className="inactive-state"
                    fill="#7A7D85"
                    fillOpacity="0.4"
                    d="M26.815 6.918C23.819 3.922 18.883 4.009 16 7.196c-2.884-3.189-7.82-3.273-10.815-.278A7.41 7.41 0 0 0 3 12.193c0 1.993.776 3.867 2.185 5.275L16 28.283l10.815-10.816C28.224 16.059 29 14.186 29 12.193s-.776-3.866-2.185-5.275z"
                    transform="scale(1)"
                    stroke="white"
                    strokeOpacity="0.8"
                    strokeWidth="2"
                />
                <path
                    className="active-state"
                    fill="#F85D5D"
                    d="M26.815 6.918C23.819 3.922 18.883 4.009 16 7.196c-2.884-3.189-7.82-3.273-10.815-.278A7.41 7.41 0 0 0 3 12.193c0 1.993.776 3.867 2.185 5.275L16 28.283l10.815-10.816C28.224 16.059 29 14.186 29 12.193s-.776-3.866-2.185-5.275z"
                    transform="translate(16 16) scale(0)"
                    stroke="#F85D5D"
                    strokeOpacity="0.2"
                    strokeWidth="2"
                />
            </svg>
        </button>
    );
};

FavoriteButton.propTypes = {
    isFavorite: bool,
    onChange: func,
};

export default FavoriteButton;
